import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { useStateValue } from "../../context/store";
import { withRouter } from "react-router-dom";
import Utils from "../../utils/utils";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../constants";
import { defaultValues } from "./models";
import {
  getPostulateStatus,
  getApplicationStage,
  getApplicationStageResultList,
  startSelectionProcess,
  getApplicationStageByPostulate,
} from "../../actions/selectionProcess-actions";
import { getPostulateStatusValues } from "../../actions/dummy-actions";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    margin: "auto",
    marginTop: "40px",
    minHeight: "40vh",
    width: "95%",
  },
  cardheader: {
    fontWeight: "bolder",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  dropdown: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    height: "35px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
  notes: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
}));

const SelectionStartProcess = (props) => {
  const idVacancie = props?.match?.params?.idVacancie;
  const personName = props?.match?.params?.personName;
  const statusPostulate = props?.match?.params?.statusPostulate;
  const chargeRequested = props?.match?.params?.chargeRequested;
  const personDocument = props?.match?.params?.personDocument;
  const postulateId = props?.match?.params?.postulateId;

  const statusValues = getPostulateStatusValues();

  const [showRecommendations, setShowRecommendations] = useState(false);
  const classes = useStyles();
  const [{ breadCrumb }, dispatch] = useStateValue();

  const [postulateStatus, setPostulateStatus] = useState([]);
  const [applicationStage, setApplicationStage] = useState([]);
  const [applicationStageResultList, setApplicationStageResultList] = useState(
    []
  );

  const [isValidRecommendations, setIsValidRecommendations] = useState(true);
  const [
    isValidRhInterviewRecommendations,
    setIsValidRhInterviewRecommendations,
  ] = useState(true);
  const [
    isValidLeaderProcessInterviewRecommendations,
    setIsValidLeaderProcessInterviewRecommendations,
  ] = useState(true);
  const [
    isValidPsychotechnicalTestRecommendations,
    setIsValidPsychotechnicalTestRecommendations,
  ] = useState(true);
  const [
    isValidKnowledgeTestRecommendations,
    setIsValidKnowledgeTestRecommendations,
  ] = useState(true);

  const [
    isValidMedicalTestRecommendations,
    setIsValidMedicalTestRecommendations,
  ] = useState(true);

  const [recursoHumano, setRecursoHumano] = useState({});
  const [liderProceso, setLiderProceso] = useState({});
  const [psicotecnica, setPsicotecnica] = useState({});
  const [conocimiento, setConocimiento] = useState({});

  const [medico, setMedico] = useState({});

  const [applicationStageByPostulate, setApplicationStageByPostulate] =
    useState({});

  const [isLoading, setIsLoading] = useState(false);

  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    oneButtons: false,
    handleClickOut: () => {},
    handleClick: () => {},
    type: "",
    title: "",
  });

  const fillFields = (applicationStageResponseList) => {
    let dat = {
      FAVORABLE: "Favorable",
      FAVORABLE_WITH_RECOMMENDATION: "Favorable con recomendaciones",
      NO_FAVORABLE: "No favorable",
    };
    let options = Utils.convertObjectToKeyNameObject(dat);
    if (applicationStageResponseList.length > 0) {
      let recommendations = applicationStageResponseList.find(
        (x) => x.result === "Favorable con recomendaciones"
      );
      if (recommendations) {
        setShowRecommendations(true);
      }

      let rhInterview = applicationStageResponseList.find(
        (as) => as.description === "Entrevista De RRHH"
      );

      if (rhInterview) {
        let name = options.find((x) => x.value === rhInterview.result);
        setValue("rhInterview", name.key);
      }
      let leaderProcessInterview = applicationStageResponseList.find(
        (as) => as.description === "Entrevista Líder Del Proceso"
      );
      if (leaderProcessInterview) {
        let name = options.find(
          (x) => x.value === leaderProcessInterview.result
        );
        setValue("leaderProcessInterview", name.key);
      }
      let psychotechnicalTest = applicationStageResponseList.find(
        (as) => as.description === "Prueba Psicotécnica"
      );
      if (psychotechnicalTest) {
        let name = options.find((x) => x.value === psychotechnicalTest.result);
        setValue("psychotechnicalTest", name.key);
      }
      let knowledgeTest = applicationStageResponseList.find(
        (as) => as.description === "Examen De Conocimiento"
      );
      if (knowledgeTest) {
        let name = options.find((x) => x.value === knowledgeTest.result);
        setValue("knowledgeTest", name.key);
      }
      let medicalTest = applicationStageResponseList.find(
        (as) => as.description === "Examen Médico"
      );
      if (medicalTest) {
        let name = options.find((x) => x.value === medicalTest.result);
        setValue("medicalTest", name.key);
      }
    }
  };

  useEffect(() => {
    const getAllPostulateStatus = async () => {
      const response = await getPostulateStatus();
      let responsePostulateStatus = response.data && response.data;
      responsePostulateStatus = Utils.convertObjectToKeyNameObject(
        responsePostulateStatus
      );
      setPostulateStatus(responsePostulateStatus);
    };
    getAllPostulateStatus();

    const getAllApplicationStage = async () => {
      const response = await getApplicationStage();
      let responseApplicationStage =
        response.data && response.data.applicationStageResponseList;
      setApplicationStage(responseApplicationStage);
      setRecursoHumano(
        responseApplicationStage.find(
          (as) => as.description === "Entrevista De RRHH"
        )
      );
      setLiderProceso(
        responseApplicationStage.find(
          (as) => as.description === "Entrevista Líder Del Proceso"
        )
      );
      setPsicotecnica(
        responseApplicationStage.find(
          (as) => as.description === "Prueba Psicotécnica"
        )
      );
      setConocimiento(
        responseApplicationStage.find(
          (as) => as.description === "Examen De Conocimiento"
        )
      );
      setMedico(
        responseApplicationStage.find(
          (as) => as.description === "Examen Médico"
        )
      );
    };
    getAllApplicationStage();

    const getAllApplicationStageResultList = async () => {
      const response = await getApplicationStageResultList();
      let responseApplicationStageResultList = response.data && response.data;
      responseApplicationStageResultList = Utils.convertObjectToKeyNameObject(
        responseApplicationStageResultList
      );
      setApplicationStageResultList(responseApplicationStageResultList);
    };
    getAllApplicationStageResultList();

    const getApplicationStageByPostulateAsync = async () => {
      const response = await getApplicationStageByPostulate(postulateId);
      var postulateData = response?.data;
      setApplicationStageByPostulate(postulateData);
      setValue("recommendations", postulateData?.recommendations);
      fillFields(postulateData?.applicationStageResponseList);
    };
    getApplicationStageByPostulateAsync();

    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Iniciar Proceso",
      breadCrumbSubText: "Iniciar Proceso",
      index: 12,
    });
  }, []);

  const schema = yup.object().shape({
    documentNumber: yup.string().nullable().required(REQUIRED_MESSAGE),
    rhInterview: yup.string().nullable().notRequired(),
    leaderProcessInterview: yup.string().nullable().notRequired(),
    status: yup.string().nullable().required(REQUIRED_MESSAGE),
    psychotechnicalTest: yup.string().nullable().notRequired(),
    knowledgeTest: yup.string().nullable().notRequired(),
    medicalTest: yup.string().nullable().notRequired(),
    recommendations: yup
      .string()
      .required("")
      .min(10, "Ingrese mínimo 10 caracteres")
      .max(200, "Ingrese máximo 200 caracteres"),
  });

  var status = statusValues.find((x) => x.key === statusPostulate);
  defaultValues.status = status.name;
  defaultValues.documentNumber = personDocument;
  defaultValues.vacant = chargeRequested;

  const { register, handleSubmit, control, setValue, errors, getValues } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues,
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const onSubmit = (data) => {
    setConfirm(() => ({
      open: true,
      question: `¿Está seguro que desea el registro?`,
      type: "QUESTION",
      handleClick: () => onSubmitFinalize(data),
      handleClickOut: closeModal,
    }));
  };

  const onSubmitFinalize = async (data) => {
    setIsLoading(true);
    closeModal();
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const getIsSelected = (fieldsStatus, currentData) => {
    let count = 0;
    let finalStatus = "";
    fieldsStatus.forEach((element) => {
      count += !currentData[element].includes("NO_FAVORABLE") ? 1 : 0;
    });
    if (count === 5) {
      finalStatus = "SELECTED";
    }

    return finalStatus;
  };
  const getIsRejected = (fieldsStatus, currentData) => {
    let count = 0;
    let finalStatus = "";
    fieldsStatus.forEach((element) => {
      count += currentData[element] && currentData[element].includes("NO_FAVORABLE") ? 1 : 0;
    });
    if (count > 0) {
      finalStatus = "REJECTED";
    }

    return finalStatus;
  };

  const getStatus = (currentData, applicationStageList) => {
       let fieldsStatus = [
      "knowledgeTest",
      "leaderProcessInterview",
      "medicalTest",
      "psychotechnicalTest",
      "rhInterview",
    ];
    let finalStatus = "";

    if (applicationStageList.length === 5) {
      finalStatus = getIsSelected(fieldsStatus, currentData);
      if (finalStatus === "") {
        finalStatus = getIsRejected(fieldsStatus, currentData);
      }
    } else {
      if (applicationStageList.length === 0) {
        finalStatus = "IN_PROCESS";
      } else {
        finalStatus = getIsRejected(fieldsStatus, currentData);
        if (finalStatus === "") {
          finalStatus = "IN_PROCESS";
        }
      }
    }
    return finalStatus;
  };

  const startProcess = () => {
    var currentData = getValues();
    setIsLoading(true);
    let applicationStageList = [];

    if (currentData.rhInterview) {
      var rh = {
        id: recursoHumano?.id,
        result: currentData.rhInterview ? currentData.rhInterview : "",
      };
      applicationStageList.push(rh);
    }

    if (currentData.leaderProcessInterview) {
      var lp = {
        id: liderProceso?.id,
        result: currentData.leaderProcessInterview
          ? currentData.leaderProcessInterview
          : "",
      };
      applicationStageList.push(lp);
    }

    if (currentData.psychotechnicalTest) {
      var ps = {
        id: psicotecnica?.id,
        result: currentData.psychotechnicalTest
          ? currentData.psychotechnicalTest
          : "",
      };
      applicationStageList.push(ps);
    }

    if (currentData.knowledgeTest) {
      var kt = {
        id: conocimiento?.id,
        result: currentData.knowledgeTest ? currentData.knowledgeTest : "",
      };
      applicationStageList.push(kt);
    }

    if (currentData.medicalTest) {
      var mt = {
        id: medico?.id,
        result: currentData.medicalTest ? currentData.medicalTest : "",
      };
      applicationStageList.push(mt);
    }

    closeModal();


    var status = getStatus(currentData, applicationStageList);

    var startProcess = {
      id: postulateId,
      status,
      applicationStageList,
      recommendations: currentData.recommendations,
    };

    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Iniciar Proceso",
      breadCrumbSubText: "Iniciar Proceso",
      index: 12,
      isSaveStartProcess: false,
    });

    startSelectionProcess(startProcess, dispatch).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 399) {
          setIsLoading(false);
          let message = "Registro guardado exitosamente";
          setConfirm({
            open: true,
            question: message,
            type: "SUCCESS",
            oneButtons: true,
            //handleClickOut: cancel,
            handleClick: cancel,
            title: "",
          });
        } else {
          setIsLoading(false);
          dispatch({
            type: "OPEN_SNACKBAR",
            openMessage: {
              open: true,
              message: response?.data ? response?.data?.detail : ERROR_MESSAGE,
            },
          });
        }
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error ? error?.detail : ERROR_MESSAGE,
          },
        });
      }
    );
  };

  const onChangeStage = (e, stage) => {
    e.preventDefault();
    let formData = getValues();
    const { value, name } = e.target;

    if (value === "FAVORABLE_WITH_RECOMMENDATION") {
      setShowRecommendations(true);
    } else {
      var currentData = getValues();
      if (
        currentData.rhInterview === "FAVORABLE_WITH_RECOMMENDATION" ||
        currentData.leaderProcessInterview ===
          "FAVORABLE_WITH_RECOMMENDATION" ||
        currentData.psychotechnicalTest === "FAVORABLE_WITH_RECOMMENDATION" ||
        currentData.knowledgeTest === "FAVORABLE_WITH_RECOMMENDATION" ||
        currentData.medicalTest === "FAVORABLE_WITH_RECOMMENDATION"
      ) {
        setShowRecommendations(true);
      } else {
        setShowRecommendations(false);
        setValue("recommendations", "");
      }
    }
  };

  const cancelConfirm = () => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que NO desea continuar creando el registro?",
      handleClick: cancel,
      handleClickOut: closeModal,
      type: "QUESTION",
    }));
  };

  const validateLength = (text) => {
    if (text.length < 10 || text.length > 200) {
      return false;
    } else {
      return true;
    }
  };

  const startProcessConfirm = () => {
    let formData = getValues();

    let isValidRhInterviewRecommendationsOption = true;
    let isValidLeaderProcessInterviewRecommendationsOption = true;
    let isValidPsychotechnicalTestRecommendationsOption = true;
    let isValidKnowledgeTestRecommendationsOption = true;

    let isValidMedicalTestRecommendationsOption = true;

    if (formData.rhInterview === "FAVORABLE_WITH_RECOMMENDATION") {
      isValidRhInterviewRecommendationsOption = validateLength(
        formData.recommendations
      );
      setIsValidRhInterviewRecommendations(
        validateLength(formData.recommendations)
      );
    }
    if (formData.leaderProcessInterview === "FAVORABLE_WITH_RECOMMENDATION") {
      isValidLeaderProcessInterviewRecommendationsOption = validateLength(
        formData.recommendations
      );
      setIsValidLeaderProcessInterviewRecommendations(
        validateLength(formData.recommendations)
      );
    }
    if (formData.psychotechnicalTest === "FAVORABLE_WITH_RECOMMENDATION") {
      isValidPsychotechnicalTestRecommendationsOption = validateLength(
        formData.recommendations
      );
      setIsValidPsychotechnicalTestRecommendations(
        validateLength(formData.recommendations)
      );
    }
    if (formData.knowledgeTest === "FAVORABLE_WITH_RECOMMENDATION") {
      isValidKnowledgeTestRecommendationsOption = validateLength(
        formData.recommendations
      );
      setIsValidKnowledgeTestRecommendations(
        validateLength(formData.recommendations)
      );
    }
    if (formData.medicalTest === "FAVORABLE_WITH_RECOMMENDATION") {
      isValidMedicalTestRecommendationsOption = validateLength(
        formData.recommendations
      );
      setIsValidMedicalTestRecommendations(
        validateLength(formData.recommendations)
      );
    }

    if (
      !isValidRhInterviewRecommendationsOption ||
      !isValidLeaderProcessInterviewRecommendationsOption ||
      !isValidPsychotechnicalTestRecommendationsOption ||
      !isValidKnowledgeTestRecommendationsOption ||
      !isValidMedicalTestRecommendationsOption
    ) {
      if (showRecommendations && !formData.recommendations) {
        setIsValidRecommendations(false);
      } else {
        setIsValidRecommendations(true);
      }

      return false;
    }
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que desea crear el registro?",
      handleClick: startProcess,
      handleClickOut: closeModal,
      type: "QUESTION",
    }));
  };

  const cancel = () => {
    closeModal();
    props.history.push(`/dashboard/users-postulates/${idVacancie}`);
  };

  if (breadCrumb?.isCancelStartProcess) {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Iniciar Proceso",
      breadCrumbSubText: "Iniciar Proceso",
      index: 12,
      isCancelStartProcess: false,
    });
    setTimeout(() => {
      cancelConfirm();
    }, 100);
  }

  if (breadCrumb?.isSaveStartProcess) {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Iniciar Proceso",
      breadCrumbSubText: "Iniciar Proceso",
      index: 12,
      isSaveStartProcess: false,
    });

    setTimeout(() => {
      startProcessConfirm();
    }, 100);
  }

  const addValuesToMemory = (e) => {
    const { name, value } = e.target;
    if (value.length > 0) {
      setIsValidRecommendations(true);
    } else {
      setIsValidRecommendations(false);
    }
  };

  return (
    <>
      <Card className={classes.root}>
        <CardHeader
          titleTypographyProps={{ variant: "h6" }}
          title={personName}
        />
        <CardContent style={{ backgroundColor: "#BCE5EE", minHeight: "40vh" }}>
          <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    inputRef={register}
                    className={classes.dropdown}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                    label="Número de Documento"
                    name="documentNumber"
                    size="small"
                    error={
                      !!errors.hasOwnProperty("documentNumber") &&
                      errors["documentNumber"].message
                    }
                    helperText={
                      errors.hasOwnProperty("documentNumber") &&
                      errors["documentNumber"].message
                    }
                  />
                </FormControl>
              </Grid>
              {recursoHumano && recursoHumano?.status === "Activo" && (
                <Grid item xs={12} md={6} lg={4}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={
                      !!errors.hasOwnProperty("rhInterview") &&
                      errors["rhInterview"].message
                    }
                  >
                    <InputLabel
                      htmlFor="outlined-select-rhInterview"
                      shrink={true}
                    >
                      Entrevista de RRHH
                    </InputLabel>
                    <Controller
                      fullWidth
                      control={control}
                      inputRef={register}
                      notched={true}
                      size="small"
                      name="rhInterview"
                      render={(props) => (
                        <Select
                          className={classes.dropdown}
                          label="Entrevista de RRHH"
                          notched={true}
                          inputProps={{
                            name: "rhInterview",
                            id: "outlined-select-rhInterview",
                          }}
                          onChange={(e) => {
                            props.onChange(e);
                            onChangeStage(e, "showRhInterviewRecommendations");
                          }}
                          value={props.value}
                        >
                          {applicationStageResultList.map((op) => (
                            <MenuItem
                              className={classes.menuItem}
                              key={op.key}
                              value={op.key}
                            >
                              {op.value}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Grid>
              )}

              {liderProceso && liderProceso.status === "Activo" && (
                <Grid item xs={12} md={6} lg={4}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={
                      !!errors.hasOwnProperty("leaderProcessInterview") &&
                      errors["leaderProcessInterview"].message
                    }
                  >
                    <InputLabel
                      htmlFor="outlined-select-leaderProcessInterview"
                      shrink={true}
                    >
                      Entrevista Líder del proceso
                    </InputLabel>
                    <Controller
                      fullWidth
                      control={control}
                      inputRef={register}
                      notched={true}
                      size="small"
                      name="leaderProcessInterview"
                      render={(props) => (
                        <Select
                          className={classes.dropdown}
                          label="Entrevista Líder del proceso"
                          notched={true}
                          inputProps={{
                            name: "leaderProcessInterview",
                            id: "outlined-select-leaderProcessInterview",
                          }}
                          onChange={(e) => {
                            props.onChange(e);
                            onChangeStage(
                              e,
                              "showLeaderProcessInterviewRecommendations"
                            );
                          }}
                          value={props.value}
                        >
                          {applicationStageResultList.map((op) => (
                            <MenuItem
                              className={classes.menuItem}
                              key={op.key}
                              value={op.key}
                            >
                              {op.value}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    inputRef={register}
                    className={classes.dropdown}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                    label="Estado"
                    name="status"
                    size="small"
                    error={
                      !!errors.hasOwnProperty("status") &&
                      errors["status"].message
                    }
                    helperText={
                      errors.hasOwnProperty("status") &&
                      errors["status"].message
                    }
                  />
                </FormControl>
              </Grid>

              {psicotecnica && psicotecnica?.status === "Activo" && (
                <Grid item xs={12} md={6} lg={4}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={
                      !!errors.hasOwnProperty("psychotechnicalTest") &&
                      errors["psychotechnicalTest"].message
                    }
                  >
                    <InputLabel
                      htmlFor="outlined-select-psychotechnicalTest"
                      shrink={true}
                    >
                      Prueba psicotécnica
                    </InputLabel>
                    <Controller
                      fullWidth
                      control={control}
                      inputRef={register}
                      notched={true}
                      size="small"
                      name="psychotechnicalTest"
                      render={(props) => (
                        <Select
                          className={classes.dropdown}
                          label="Prueba psicotécnica"
                          notched={true}
                          inputProps={{
                            name: "psychotechnicalTest",
                            id: "outlined-select-psychotechnicalTest",
                          }}
                          onChange={(e) => {
                            props.onChange(e);

                            onChangeStage(
                              e,
                              "showPsychotechnicalTestRecommendations"
                            );
                          }}
                          value={props.value}
                        >
                          {applicationStageResultList.map((op) => (
                            <MenuItem
                              className={classes.menuItem}
                              key={op.key}
                              value={op.key}
                            >
                              {op.value}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Grid>
              )}

              {conocimiento && conocimiento.status === "Activo" && (
                <Grid item xs={12} md={6} lg={4}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={
                      !!errors.hasOwnProperty("knowledgeTest") &&
                      errors["knowledgeTest"].message
                    }
                  >
                    <InputLabel
                      htmlFor="outlined-select-knowledgeTest"
                      shrink={true}
                    >
                      Examen de conocimiento
                    </InputLabel>
                    <Controller
                      fullWidth
                      control={control}
                      inputRef={register}
                      notched={true}
                      size="small"
                      name="knowledgeTest"
                      render={(props) => (
                        <Select
                          className={classes.dropdown}
                          label="Examen de conocimiento"
                          notched={true}
                          inputProps={{
                            name: "knowledgeTest",
                            id: "outlined-select-knowledgeTest",
                          }}
                          onChange={(e) => {
                            props.onChange(e);
                            onChangeStage(
                              e,
                              "showKnowledgeTestRecommendations"
                            );
                          }}
                          value={props.value}
                        >
                          {applicationStageResultList.map((op) => (
                            <MenuItem
                              className={classes.menuItem}
                              key={op.key}
                              value={op.key}
                            >
                              {op.value}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    inputRef={register}
                    className={classes.dropdown}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                    label="Vacante"
                    name="vacant"
                    size="small"
                    error={
                      !!errors.hasOwnProperty("vacant") &&
                      errors["vacant"].message
                    }
                    helperText={
                      errors.hasOwnProperty("vacant") &&
                      errors["vacant"].message
                    }
                  />
                </FormControl>
              </Grid>

              {medico && medico?.status === "Activo" && (
                <Grid item xs={12} md={6} lg={4}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={
                      !!errors.hasOwnProperty("medicalTest") &&
                      errors["medicalTest"].message
                    }
                  >
                    <InputLabel
                      htmlFor="outlined-select-medicalTest"
                      shrink={true}
                    >
                      Exámenes médicos
                    </InputLabel>
                    <Controller
                      fullWidth
                      control={control}
                      inputRef={register}
                      notched={true}
                      size="small"
                      name="medicalTest"
                      render={(props) => (
                        <Select
                          className={classes.dropdown}
                          label="Exámenes médicos"
                          notched={true}
                          inputProps={{
                            name: "medicalTest",
                            id: "outlined-select-medicalTest",
                          }}
                          onChange={(e) => {
                            props.onChange(e);

                            onChangeStage(e, "showMedicalTestRecommendations");
                          }}
                          value={props.value}
                        >
                          {applicationStageResultList.map((op) => (
                            <MenuItem
                              className={classes.menuItem}
                              key={op.key}
                              value={op.key}
                            >
                              {op.value}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Grid>
              )}

              <Grid
                item
                xs={12}
                md={6}
                lg={12}
                style={showRecommendations ? {} : { display: "none" }}
              >
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    className={classes.notes}
                    label="Recomendaciones *"
                    name="recommendations"
                    placeholder="Recomendaciones *"
                    onChange={addValuesToMemory}
                    multiline
                    rows={3}
                    rowsMax={3}
                    InputLabelProps={{ shrink: true }}
                    error={
                      !!errors.hasOwnProperty("recommendations") &&
                      errors["recommendations"].message
                    }
                  />
                  <FormHelperText style={{ color: "#f44336" }}>
                    {!!errors.hasOwnProperty("recommendations") &&
                      errors["recommendations"].message}

                    {!isValidRecommendations && REQUIRED_MESSAGE}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
      <ModalConfirmBase
        description={confirm.question}
        open={confirm.open}
        handleClick={confirm.handleClick}
        handleClickOut={confirm.handleClickOut}
        type={confirm.type}
        oneButtons={confirm.oneButtons}
        title={confirm.title}
      />
    </>
  );
};

export default withRouter(SelectionStartProcess);
